import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus-icon",
  "use": "icon-minus-icon-usage",
  "viewBox": "0 0 15.575 2.245",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.575 2.245\" id=\"icon-minus-icon\">\n  <path id=\"icon-minus-icon_np_minus_2076551_000000\" d=\"M1.132,45.038h13.31a1.122,1.122,0,1,0,0-2.245H1.132a1.122,1.122,0,1,0,0,2.245Z\" transform=\"translate(0 -42.793)\" fill=\"#4c4c4c\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/minus-icon.svg
// module id = 150
// module chunks = 0 1 2